/* Base JS methods */

//cloning currentStorePath
//for array cloning performance reference: http://jsben.ch/#/wQ9RU
export function cloneArray(array) {
    return array.slice();
}
